import axios from "axios"
import baseURL from "../configs/api"

export const getLocations = (tenantId: string) => {
    return getFetch("location", tenantId);
}

export const getLocation = (primaryKey: string, tenantId: string) => {
    return getFetch(`location/${primaryKey}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}